// extracted by mini-css-extract-plugin
export default {"container":"style_container__Gz-A-","content":"style_content__wqPMt"};